<template>
  <div class="home-page-wrapper" ref="wrapperRef">
    <div class="home-page-inner" ref="innerRef">
      <div class="home-container">
        <div class="home">
          <HDFHeader03 />
      
          <div class="bg-container">
            <div class="banner-bg">
              <div class="items">
                <!-- <el-popover
                  class="popover-container"
                  title=""
                  content="..."
                  placement="left"
                  width="fit-content"
                >
                  <template #reference>
                    <div class="item one"></div>
                  </template>
                  <div class="popover-box">敬请期待</div>
                </el-popover>
                
                <div class="item one">
                  <a :href="configState.indexRedmodelDjks.value.jumpTo ? configState.indexRedmodelDjks.value.url : 'javascript:;'" target="_blank">
                    <el-image :src="configState.indexRedmodelDjks.value.data" :fit="fit"></el-image>
                  </a>
                </div> -->
                <div class="item one">
                  <a :href="configState.indexRedmodelVideo.value.jumpTo ? configState.indexRedmodelVideo.value.url : 'javascript:;'" target="_blank">
                    <el-image :src="configState.indexRedmodelVideo.value.data" :fit="fit"></el-image>
                  </a>
                </div>

                <!-- <div class="item one">未来智领</div> -->
                
                <el-popover
                  class="popover-container"
                  title=""
                  content=""
                  placement="left"
                  width="fit-content"
                >
                  <template #reference>
                    <div class="item three"></div>
                  </template>
                  <div class="erweima popover-box"></div>
                </el-popover>

                <el-popover
                  class="popover-container"
                  title=""
                  content=""
                  placement="left"
                  width="fit-content"
                >
                  <template #reference>
                    <div class="item two"></div>
                  </template>
                  <div class="popover-box">400-775-5269</div>
                </el-popover>
              </div>
              <div class="banner-bg-white">
                <el-carousel height="100%" arrow="never">
                  <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                    <img :src="item.img" />
                  </el-carousel-item>
                </el-carousel>
              </div>
              <!-- <div class="banner-bg-computer"></div> -->
            </div>
            <Member365 :buyClick="buyVipClick"/>
          </div>
      
          <div class="main-content">
            <img class="model-img" src="@/assets/images/index-model-004.jpg">
          </div>
      
          <div class="three-product-container">
            <div class="bg-red"></div>
            <ThreeProduct :buyClick="buyVipClick"/>
             <!-- <div style="width: 100%;height: 500px;"></div> -->
            <div class="bg-blue"></div>

            <!-- 引流课程 -->
            <div class="yellow-block-container" v-if="displayYellowBlockList">
              <div class="yellow-block-items">
                <!-- <img src="@/assets/images/home/left-arrow.png" alt="" class="left-arrow arrow" @click="handleClickLeft">
                <div class="yellow-block" v-for="(item, index) in displayYellowBlockList" :key="index" @click="clickTitle(item)">
                  <div class="title1">{{ item.title }}</div>
                  <div class="title2" v-if="item.subTitle">{{ item.subTitle }}</div>
                </div>
                <img src="@/assets/images/home/right-arrow.png" alt="" class="right-arrow arrow" @click="handleClickRight"> -->
                <HorizontalScrolling  
                  :items="displayYellowBlockList" 
                  :items-per-screen="2" >
                  <template #item="{ item }">
                    <div class="yellow-block" @click="clickTitle(item)">
                      <div class="title1">{{ item.title }}</div>
                      <div class="title2" v-if="item.subTitle">{{ item.subTitle }}</div>
                    </div>
                  </template>
                  <template #left-arrow>
                    <img src="@/assets/images/home/left-arrow.png" class="left-arrow arrow">
                  </template>
                  <template #right-arrow>
                    <img src="@/assets/images/home/right-arrow.png" class="right-arrow arrow">
                  </template>
                </HorizontalScrolling>
              </div>
            </div>
            

            <div class="yellow-block-txt">
              <div class="yellow-block-txt-item">
                <div class="img-box"></div>
                <div class="num">5000+</div>
                <div class="line"></div>
                <div class="content">特长学生</div>
              </div>
              <div class="yellow-block-txt-item">
                <div class="img-box"></div>
                <div class="num">50+</div>
                <div class="line"></div>
                <div class="content">竞赛考级</div>
              </div>
              <div class="yellow-block-txt-item">
                <div class="img-box"></div>
                <div class="num">100%</div>
                <div class="line"></div>
                <div class="content">全覆盖</div>
              </div>
              <div class="yellow-block-txt-item">
                <div class="img-box"></div>
                <div class="num">1000+</div>
                <div class="line"></div>
                <div class="content">名校助教答疑</div>
              </div>
            </div>
          </div>
      
          <!-- 教师介绍 -->
          <!-- <HDFTeacherList /> -->

          <div class="video-box">
            <ImagesGridPage
              :images="imageList"
              :columns="4"
              :rows="3"
              image-width="100%"
              image-height="400px"
              @image-click="handleImageClick"
            />
          </div>
          
          <HDFFooter03 />
        </div>

        <!-- 视频播放器弹窗 -->
      <el-dialog
          v-model="indexVideoPlayDialogVisible"
          title="视频播放器"
          width="770"
          :before-close="handleClose"
          append-to-body
        >
          <video
            v-if="videoUrl"
            :src="videoUrl"
            controls
            autoplay
            style="width: 100%; height: auto;"
            @contextmenu.prevent
            controlsList="nodownload"
          ></video>
          <p v-else>请提供视频链接</p>
          <template #footer>
            <el-button @click="handleClose">关闭</el-button>
          </template>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script setup>
import HDFHeader03 from '@/components/HDFHeader03.vue'
import HDFFooter03 from '@/components/HDFFooter03.vue'
import ThreeProduct from '@/components/ThreeProduct.vue'
import Member365 from '@/components/HDFMember365.vue'
import HDFTeacherList from '@/components/HDFTeacherList.vue'
import ImagesGridPage from '@/components/ImagesGridPage.vue'
import HorizontalScrolling from '@/components/HorizontalScrolling.vue'

import { ref, onMounted, onBeforeUnmount } from 'vue'
import { getIndexBannerList, getTitleDataList, apiGetIndexVideoList, apiGetIndexVideoPlayUrl } from '@/api/index'
import { GetUserInfo } from '@/api/api.js'
import { jumpBlankUrl } from '@/utils/jump'
import { useConfigStore } from '@/stores'
import { storeToRefs } from 'pinia'
import { getToken } from '@/utils/common'

const configStore = useConfigStore()
const configState = storeToRefs(configStore)

const yellowBlockList = ref([])
const displayYellowBlockList = ref([])


const curIndex = ref(0)

const indexVideoPlayDialogVisible = ref(false);
const videoUrl = ref('');

const openDialog = (url) => {
  videoUrl.value = url;
  indexVideoPlayDialogVisible.value = true;
};

const handleClose = () => {
  indexVideoPlayDialogVisible.value = false;
  videoUrl.value = '';
};

const imageList = ref([]);
const handleImageClick = (data) => {
  apiGetIndexVideoPlayUrl({id: data.id}).then(response => { 
    const res = response.data;
    if(res.code == 200){ 
      openDialog(res.data)
    }
  })
};

const handleClickLeft = () => {
  if (yellowBlockList.value.length <= 2) {
    return;
  }
  curIndex.value -= 2
  if (curIndex.value < 0) {
    curIndex.value = yellowBlockList.value.length - 2
  }
  displayYellowBlockList.value = yellowBlockList.value.slice(curIndex.value, curIndex.value + 2)
}

const handleClickRight = () => {
  if (yellowBlockList.value.length <= 2) {
    return;
  }
  curIndex.value += 2
  if (curIndex.value > yellowBlockList.value.length - 2) {
    curIndex.value = 0
  }
  displayYellowBlockList.value = yellowBlockList.value.slice(curIndex.value, curIndex.value + 2)
}

const bannerList = ref([])

const clickTitle = (titleData) => {
  if(titleData.jumpType == 'def'){
    window.open('/zms?id='+titleData.url, '_blank')
  }else if(titleData.jumpType == 'url'){
    window.open(titleData.url, '_blank')
  }else if(titleData.jumpType == 'auth'){
    jumpBlankUrl(titleData.url)
  }
}

const buyVipClick = (code) => {
  window.location.href='/personalRole'
}

const getBannerList = () => {
  getIndexBannerList().then(response => {
    const res = response.data;
    if(res.code == 200){
      bannerList.value = res.data;
    }
  })
}

const getTitleList = () => {
  getTitleDataList().then(response => {
    const res = response.data;
    if(res.code == 200){
      displayYellowBlockList.value = res.data;
    }
  })
}

const getIndexVideoList = () => { 
  apiGetIndexVideoList().then(response => {
    const res = response.data;
    if(res.code == 200){
      const list = res.data;
      imageList.value = list.map(item => {
        return {
          src: item.img,
          caption: item.name,
          id: item.id
        }
      })
    }
  })
}

onMounted(() => {
  displayYellowBlockList.value = yellowBlockList.value.slice(curIndex.value, curIndex.value + 2)
  getBannerList();
  getTitleList();
  getIndexVideoList();

  // 静默获取用户信息，用于刷新头部登录状态
  const token = getToken();
  if (token) {
    GetUserInfo({}, {}, null, true);
  }
})

// TODO 请求数据

// ========== 首页 1920px 缩放适配 ==========
const wrapperRef = ref(null)
const innerRef = ref(null)
const MAX_WIDTH = 1920 // 界面最大宽度
const SCALE_WIDTH = 1920 // 缩放基准宽度

const handleHomeResize = () => {
  if (!innerRef.value || !wrapperRef.value) return
  
  const screenWidth = window.innerWidth
  
  if (screenWidth < SCALE_WIDTH) {
    // 小于1920px时进行等比例缩放
    const scale = screenWidth / SCALE_WIDTH
    innerRef.value.style.transform = `scale(${scale})`
    innerRef.value.style.transformOrigin = 'top left'
    innerRef.value.style.margin = '0'
    
    setTimeout(() => {
      const unscaledHeight = innerRef.value.scrollHeight
      wrapperRef.value.style.height = `${unscaledHeight * scale}px`
    }, 50)
  } else {
    // 大于等于1920px时保持原始大小并居中
    wrapperRef.value.style.height = 'auto'
    innerRef.value.style.transform = 'none'
    innerRef.value.style.margin = '0 auto'
  }
}

onMounted(() => {
  handleHomeResize()
  window.addEventListener('resize', handleHomeResize)
  window.addEventListener('load', handleHomeResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleHomeResize)
  window.removeEventListener('load', handleHomeResize)
})
</script>

<style scoped>
/* ========== 首页缩放容器 ========== */
.home-page-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.home-page-inner {
  width: 1920px;
  margin: 0 auto;
  transform-origin: top left;
}

/* ========== 原有首页样式 ========== */
.home-container {
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  position: relative;
}
.bg-container {
  position: relative;
  width: 100%;
  height: 1074px;
}
.banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 950px;
  background: url(@/assets/images/home/banner-bg-004.jpg) no-repeat;
  background-size: 100% 100%;
}
.banner-bg .items {
  position: absolute;
  top: 300px;
  right: 160px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 3;
}
.banner-bg .item {
  width: 85px;
  height: 85px;
}
.banner-bg .item.one {
  margin-top: 160px;
}
.banner-bg .item.two {
  background: url(@/assets/images/banner-item-contact.png) no-repeat;
  background-size: 100% 100%;
}
.banner-bg .item.three {
  background: url(@/assets/images/banner-item-wechat.png) no-repeat;
  background-size: 100% 100%;
}
.banner-bg .banner-bg-white {
  position: absolute;
  top: 144px;
  right: 200px;
  z-index: 2;
  width: 630px;
  height: 660px;
  background: url(@/assets/images/home/banner-bg-white.jpg) no-repeat;
  background-size: 100% 100%;
  padding: 15px;
  box-sizing: border-box;
}
.banner-bg .banner-bg-white>div {
  width: 100%;
  height: 100%;
  border-radius: 46px;
}
.banner-bg .banner-bg-computer {
  position: absolute;
  top: 554px;
  right: 770px;
  z-index: 3;
  width: 337px;
  height: 206px;
  background: url(@/assets/images/home/banner-bg-computer.jpg) no-repeat;
  background-size: 100% 100%;
}

.popover-container {
  padding: 10px;
  background-color: blue;
}
:deep(.el-popover) {
    background-color: red;
}
.erweima {
  background: url(@/assets/images/banner-item-wechat2.jpg) no-repeat;
  width: 140px;
  height: 140px;
  background-size: 100% 100%;
}
.popover-box {
  width: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
}

.main-content {
  width: 100%;
}
.main-content .model-img{
  width: 100%;
}

/******************************** 三个产品 开始 *****************************************/
.three-product-container {
  position: relative;
}
.bg-red {
  width: 100%;
  height: 50px;
  background: rgba(214, 21, 24, 1);
}
.bg-blue {
  width: 100%;
  height: 50px;
  background: rgba(2, 50, 99, 1);
}
/******************************** 引流课程 *****************************************/
.yellow-block-container {
  color: rgba(214, 21, 24, 1);
  font-size: 48px;
  position: absolute;
  top: -68px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}
.yellow-block-items {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.yellow-block {
  width: 650px;
  height: 180px;
  border-radius: 16px;
  background: rgba(246, 180, 67, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.yellow-block + .yellow-block {
  margin-left: 100px;
}
.yellow-block-txt {
  width: 1268px;
  height: 200px;
  border-radius: 24px;
  background: rgba(246, 180, 67, 1);
  position: absolute;
  bottom: -76px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  padding: 40px 50px 20px 50px;
}
.yellow-block-txt-item {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 220px;
  height: 100%;
  text-align: left;
}
.yellow-block-txt-item .img-box {
  width: 40px;
  height: 40px;
}
.yellow-block-txt-item:nth-of-type(1) .img-box {
  background: url(@/assets/images/home/yellow-block/techangxuesheng.png) no-repeat;
}
.yellow-block-txt-item:nth-of-type(2) .img-box {
  background: url(@/assets/images/home/yellow-block/jingsaikaoji.png) no-repeat;
}
.yellow-block-txt-item:nth-of-type(3) .img-box {
  background: url(@/assets/images/home/yellow-block/quanfugai.png) no-repeat;
}
.yellow-block-txt-item:nth-of-type(4) .img-box {
  background: url(@/assets/images/home/yellow-block/mingxiaozhujiaodayi.png) no-repeat;
}
.yellow-block-txt-item .num {
  font-size: 70px;
  color: #000;
  font-weight: 600;
  width: 100%;
  text-align: center;
}
.yellow-block-txt-item .line {
  width: 100%;
  border-top: 2px solid #fff;
  margin-bottom: 12px;
}
.yellow-block-txt-item .content {
  font-size: 24px;
  color: #000;
}
.arrow {
  width: 25px;
  height: 45px;
  cursor: pointer;
}
.arrow.left-arrow {
  margin-right: 40px;
  margin-top: 6px;
}
.arrow.right-arrow {
  margin-left: 40px;
  margin-top: 6px;
}
/******************************** 三个产品 结束 *****************************************/

.video-box{
  background: url(@/assets/images/home/teacher/teacher.jpg) no-repeat;
  background-size: 100% auto;
  padding: 50px 300px;
  margin-top: 50px;
}
</style>
